import { useEffect } from "react";
import { useNavigate } from "react-router";

import api from "utils/api";
import { useToastContext } from "context/ToastContext";

export const Interceptor = () => {
  const { notify } = useToastContext();
  const navigate = useNavigate();

  useEffect(() => {
    const responseInterceptor = api.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        const status = error?.response?.status || 911; // emergency status
        const message = error?.response?.data.message || error.message;
        const type = "danger";

        if (status === 401) {
          notify({ type, title: "Error", description: "Problem with authentication" });
          navigate("/login");
        } else if (status === 403) {
          notify({ type, title: "Not authorized", description: "You have no permissions to perform that action." });
        } else if (status === 404) {
          notify({ type, title: "Not Found", description: "The requested resource was not found." });
        } else if (status === 422) {
          notify({ type, title: "Unprocessable Content", description: message || "Request payload is not valid! Please check form details." });
        } else if (status === 400) {
          notify({ type, title: "Bad Request", description: "The server cannot process the request." });
        } else if (status === 500) {
          notify({ type, title: "API Error", description: "Please contact the developer!" });
        } else if (status === 429) {
          notify({ type, title: "Too Many Requests", description: "You have sent too many requests." });
        } else if (status === 503) {
          notify({ type, title: "Service Unavailable", description: "The service is currently unavailable." });
        } else {
          notify({ type, title: "Whoops! Something went wrong.", description: message });
        }

        return Promise.reject(error);
      },
    );

    return () => {
      api.interceptors.response.eject(responseInterceptor);
    };
  }, [navigate, notify]);

  return null;
};
